import { render, staticRenderFns } from "./AdminSendMessage.vue?vue&type=template&id=78458624&lang=pug&"
import script from "./AdminSendMessage.vue?vue&type=script&lang=js&"
export * from "./AdminSendMessage.vue?vue&type=script&lang=js&"
import style0 from "./AdminSendMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports